import map from "lodash/map";
import DownloadLink from "PFApp/components/chat/download_link";
import { Flex, Stack } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useAttachments } from "PFCore/hooks/queries/attachments/use_attachments";
import { GIdTargetType } from "PFTypes";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { dasherize } from "underscore.string";

import css from "./activity_details_common.module.scss";
import { useMetadata } from "./use_metadata";

const ActivityDetailsMoreInfo = ({ activity, metadataToOmit }) => {
  const { t } = useTranslation("activities");
  const metadata = useMetadata({ activity, metadataToOmit });

  const { data: attachments } = useAttachments(
    {
      targetId: Number(activity?.id),
      targetType: GIdTargetType.Task
    },
    { enabled: !!activity }
  );

  // wrapping div is important here because we target last-child with css
  return (
    <Stack gap="spacingLg" data-qa-id="ActivityDetailsMoreInfo" className={css.infoMore}>
      {map(
        metadata,
        (prop) =>
          prop.text && (
            <Stack
              gap="spacingMd"
              key={prop.title}
              data-qa-id={`activity-details-metadata-prop${dasherize(prop.title)}`}
            >
              <Typography variant="h6" clipOverflow>
                {prop.title}
              </Typography>
              <Typography variant="bodyRegular">
                {prop.type === "link" ? (
                  <a href={prop.text} target="_blank" rel="noopener noreferrer">
                    {prop.text}
                  </a>
                ) : (
                  <Flex
                    alignItems="center"
                    {...(prop.type === "availability"
                      ? {
                          direction: "column",
                          alignItems: "flex-start"
                        }
                      : {})}
                  >
                    {prop.title === "Location" && <Icon name="location" size="md" />}
                    <span style={{ whiteSpace: "pre-line" }}> {prop.text} </span>
                  </Flex>
                )}
              </Typography>
            </Stack>
          )
      )}

      {attachments?.entries && attachments?.entries.length > 0 && (
        <>
          <Divider />
          <Stack gap="spacingMd">
            <Typography variant="h6" clipOverflow>
              {t("show.details.attachments")}
            </Typography>
            <ul className={css.attachments}>
              {attachments?.entries.map((attachment) => (
                <li key={attachment.id}>
                  <DownloadLink attachment={attachment} useIcon={false} />
                </li>
              ))}
            </ul>
          </Stack>
        </>
      )}
    </Stack>
  );
};

ActivityDetailsMoreInfo.propTypes = {
  activity: PropTypes.object,
  metadataToOmit: PropTypes.arrayOf(PropTypes.string)
};

export default ActivityDetailsMoreInfo;
